import * as React from "react";
import { Box, Typography } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import { usePermissions } from "../../hooks/usePermissions";
import DashboardItem from "./DashboardItem.tsx";
import { allSidebarItems } from "../../utils/sidebarItems";
import { filterSidebarItems } from "../../utils/roleAccess";

/** Preferred order for the top dashboard pills; remaining items keep sidebar order. */
const DASHBOARD_PILL_ORDER = [
  "Match & Energy",
  "Themes",
  "Naming Polls",
  "Karaoke",
  "Dance",
  "Challenges",
  "Audio",
];

export default function Dashboard() {
  const { user } = usePermissions();

  // Quick links: everything this account may open except Dashboard itself,
  // with preferred pills first
  const quickLinks = filterSidebarItems(allSidebarItems, user)
    .filter((item) => item.label !== "Dashboard")
    .sort((a, b) => {
      const aIdx = DASHBOARD_PILL_ORDER.indexOf(a.label);
      const bIdx = DASHBOARD_PILL_ORDER.indexOf(b.label);
      const aRank = aIdx === -1 ? DASHBOARD_PILL_ORDER.length : aIdx;
      const bRank = bIdx === -1 ? DASHBOARD_PILL_ORDER.length : bIdx;
      return aRank - bRank;
    });

  return (
    <PageLayout
      title={`Welcome, ${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
      subtitle="Quick access to admin tools"
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1.5rem",
          marginTop: "0.5rem",
        }}
      >
        {quickLinks.map((item) => (
          <DashboardItem
            key={item.label}
            IconComponent={item.customIcon ? undefined : item.image}
            customIcon={item.customIcon}
            customIconSrc={item.image}
            pathToNavigate={item.path}
            title={item.label}
          />
        ))}
      </Box>
      {quickLinks.length === 0 && (
        <Typography color="text.secondary">
          No quick links available for your role.
        </Typography>
      )}
    </PageLayout>
  );
}
